import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoChartMixin from './KendoChartMixin'

export default {
    name: 'kendo-chart',
    mixins: [ KendoChartMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    },
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChart/index.js